import { Thead, Th } from '@chakra-ui/react'

export function PacientTHeadDesktop() {
	return (
		<Thead>
			<Th>Data</Th>
			<Th>Procedimentos</Th>
			<Th>Profissional</Th>
		</Thead>
	)
}
